const CMSLanguagesServices = (instance) => {

    const getLanguages = () => instance.get('languages/');

    return {
        getLanguages
    };
};
export default CMSLanguagesServices;